import makeStyles from '@mui/styles/makeStyles';

const sidebarStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexGrow: 1
    },
}));

export default sidebarStyles